module.exports = __webpack_public_path__ + "static/media/close.8ef77659.svg";